import { Navigate, Route, Routes, useLocation, useSearchParams } from 'react-router-dom'
import { useSitzung } from './sitzung.jsx'
import Anmelden from './seiten/Anmelden.jsx'
import Einrichten from './seiten/Einrichten.jsx'
import Monat from './seiten/Monat.jsx'
import Uebersicht from './seiten/Uebersicht.jsx'
import Abrechnung from './seiten/Abrechnung.jsx'
import Verwaltung from './seiten/Verwaltung.jsx'

// Solange /api/me noch laeuft, wissen wir nicht, ob jemand angemeldet ist.
// In dieser Zeit darf weder die Seite noch die Weiterleitung erscheinen,
// sonst blitzt bei jedem Neuladen kurz das Anmeldeformular auf.
//
// `rollen` schuetzt zusaetzlich vor dem Aufruf per Adresszeile. Die
// eigentliche Absicherung sitzt im Backend — das hier verhindert nur, dass
// jemand auf einer Seite landet, die ihm nichts sagt.
function Geschuetzt({ rollen, children }) {
  const { benutzer, laedt } = useSitzung()
  const ort = useLocation()

  if (laedt) {
    return (
      <main className="huelle">
        <p className="hinweis">Einen Moment …</p>
      </main>
    )
  }
  if (!benutzer) return <Navigate to="/anmelden" state={{ von: ort.pathname + ort.search }} replace />
  if (rollen && !rollen.includes(benutzer.rolle)) return <Navigate to="/" replace />
  return children
}

/**
 * Was hinter „/“ steckt, hängt an der Rolle.
 *
 * Verwaltung und Vorgesetzte führen keinen eigenen Stundenzettel — für sie
 * wäre die Monatsansicht des eigenen Kontos eine leere Seite. Sie landen
 * deshalb in der Übersicht. Mit ?benutzer= bleibt der Monat erreichbar.
 */
function Startseite() {
  const { benutzer } = useSitzung()
  const [parameter] = useSearchParams()

  if (benutzer.rolle !== 'mitarbeiter' && !parameter.get('benutzer')) {
    return <Navigate to="/uebersicht" replace />
  }
  return <Monat />
}

export default function App() {
  return (
    <Routes>
      <Route path="/anmelden" element={<Anmelden />} />
      <Route path="/einrichten/:token" element={<Einrichten />} />

      <Route
        path="/"
        element={
          <Geschuetzt>
            <Startseite />
          </Geschuetzt>
        }
      />
      <Route
        path="/uebersicht"
        element={
          <Geschuetzt rollen={['vorgesetzter', 'admin']}>
            <Uebersicht />
          </Geschuetzt>
        }
      />
      <Route
        path="/abrechnung"
        element={
          <Geschuetzt rollen={['admin']}>
            <Abrechnung />
          </Geschuetzt>
        }
      />
      <Route
        path="/verwaltung"
        element={
          <Geschuetzt rollen={['admin']}>
            <Verwaltung />
          </Geschuetzt>
        }
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
